import React, { useEffect, useContext } from 'react'
import AuthContext from '@/product/context/auth/authContext'
import Loaders from '@/product/components/molecules/Loaders'
import debounce from 'lodash/debounce'

function SwitchUser({ history }) {
    const authContext = useContext(AuthContext)
    const {
        loadUser,
        switchUser,
        logout,
        responseStatus: authResponseStatus,
    } = authContext

    const debouncedSwitchUser = debounce((userId) => {
        switchUser({ user_id: userId })
    }, 300)

    useEffect(() => {
        let params = new URLSearchParams(window.location.search)
        let atobUserId = atob(params.get('user_id'))
        if (atobUserId) {
            debouncedSwitchUser(atobUserId)
        } else {
            logout()
            history.push('/')
        }
    }, [])

    useEffect(() => {
        if (authResponseStatus) {
            if (authResponseStatus.status === 'success') {
                if (authResponseStatus.from === 'switchuser') {
                    loadUser()
                    history.push('/')
                }
            } else {
                logout()
                history.push('/')
            }
        }
    }, [authResponseStatus])

    return (
        <div>
            <Loaders name="home" isLoading={true} />
        </div>
    )
}

export default SwitchUser
